import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  NumberField,
  DateField,
  ReferenceManyField,
  Datagrid,
  EditButton,
  TopToolbar,
} from 'react-admin';

const CaseCategoryShowActions = () => (
  <TopToolbar>
    <EditButton />
  </TopToolbar>
);

export const CaseCategoryShow = () => (
  <Show actions={<CaseCategoryShowActions />}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="slug" />
      <BooleanField source="isActive" />
      <NumberField source="sortOrder" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
      
      <ReferenceManyField
        reference="cases"
        target="categoryId"
        label="Кейсы в этой категории"
      >
        <Datagrid>
          <TextField source="title" />
          <TextField source="from" />
          <TextField source="to" />
          <TextField source="machine" />
          <BooleanField source="isActive" />
          <EditButton />
        </Datagrid>
      </ReferenceManyField>
    </SimpleShowLayout>
  </Show>
);
